import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import {
    createFieldDatetime,
    createFieldInput
} from "../../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../../i18n";
import { conditionFormChecker, putField } from "../../../../../../utils/form";
import { createForm, initDefaultForm } from "./sequestrate-info.logic";

const Address = defineAsyncComponent(() => import("../../../../../../components/address/Address"));

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext, informProduct } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    if (key && !lodash.get(modelRef, key)) {
        lodash.set(modelRef, key, createForm());
    }
    const model = initDefaultForm({ props, data, key });
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldDatetime({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}sequestrateDatetime`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                label: () => `${i18n.global.t("model.sequestrate.sequestrateDatetime")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.sequestrateDatetime,
                            "onUpdate:value": value => {
                                model.sequestrateDatetime = value;
                                model.isSave = true;
                                informProduct?.setSequestrates?.({ modelRef, id: informProduct?.id, sequestrates: [model] })
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}storageLocationName`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 5 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => `${i18n.global.t("model.sequestrate.storageLocationName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.storageLocationName,
                            "onUpdate:value": value => {
                                model.storageLocationName = value;
                                model.isSave = true;
                                informProduct?.setSequestrates?.({ modelRef, id: informProduct?.id, sequestrates: [model] })
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const locale = [{ name: "Th", suffix: true }];
                    return <Address
                        menuContext={menuContext}
                        viewOnly={viewOnly}
                        dataProp={data}
                        dataKey={`${prefix}addresses.0`}
                        isLoading={isLoading?.value}
                        locale={locale}
                        onUpdateSome={() => {
                            model.isSave = true;
                            informProduct?.setSequestrates?.({ modelRef, id: informProduct?.id, sequestrates: [model] })
                        }}
                    ></Address>
                }
            },
        ]
    });
};
